import React, { useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup'
import { useMutation } from '@apollo/client'
import withReactContent from 'sweetalert2-react-content'
import { Auth } from 'aws-amplify';
import Swal from 'sweetalert2'
import { RESET_PASSWORD } from "../../../utils/GraphQLAPI"
import TextField from '../TextField/TextField';


const MySwal = withReactContent(Swal)
type ResetPasswordProps = {
    userName: string
}
const initialValues = {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
}

const enrollSchema = Yup.object().shape({
    currentPassword: Yup.string().required('Current Password is required'),
    newPassword: Yup.string().required('New Password is required'),
    confirmNewPassword: Yup.string()
        .required('Confirm New Password is required')
        .oneOf([Yup.ref('newPassword')], 'Passwords do not match.')
})

const ResetPassword = ({ userName }: ResetPasswordProps) => {
    const [editMode, setEditMode] = useState(false);
    const [passwordType, setPasswordType] = useState('password')
    const [passwordShow, setPasswordShow] = useState('password')

    const ClickEditMode = () => setEditMode(true)

    const removeEditMode = () => {
        setEditMode(false)
        formik.resetForm()
    }

    const handleOnChange = (e: any, name: string) => {
        formik.setFieldValue(name, e.target.value);
    }

    const toggleConfirmPassword = () => {
        setPasswordType(prev => prev === 'password' ? 'text' : 'password')
    }

    const toggleNewPassword = () => {
        setPasswordShow(prev => prev === 'password' ? 'text' : 'password')
    }

    const [resetPassword] = useMutation(RESET_PASSWORD, {
        onCompleted: (detail) => {
            MySwal.fire({
                title: 'Password updated successfully',
                icon: 'success',
                confirmButtonColor: '#3E97FF',
            });
            localStorage.setItem('_accesstoken', detail?.resetPasswordWithApp?.accessToken)
            localStorage.setItem('_refreshtoken', detail?.resetPasswordWithApp?.refreshToken)
        }
    })

    const formik = useFormik({
        initialValues,
        validationSchema: enrollSchema,
        onSubmit: async (values) => {
            try {
                resetPassword({
                    variables: {
                        newPassword: values.newPassword,
                        userName: userName
                    }
                }

                )

            } catch (err: any) {
                MySwal.fire({
                    icon: 'error',
                    title: err.message,
                });
            }

            removeEditMode()
        }
    })

    return (
        <div className='card mt-5'>
            <div className='card-body'>
                <div className='row border-bottom'>
                    <h2 className='mb-5'>Reset Password</h2>
                </div>

                {/* View Mode */}
                {!editMode && (
                    <div className='row mt-3'>
                        <div className='col-lg-6 mt-5'>
                            <label className='mb-2'>Password</label>
                            <div className='text-muted'>**********</div>
                        </div>
                        <div className='col-lg-6 mt-5 text-end'>
                            <button
                                type='button'
                                className='btn btn-light'
                                onClick={ClickEditMode}
                            >
                                Reset Password
                            </button>
                        </div>
                    </div>
                )}

                {/* Edit Mode */}
                {editMode && (
                    <form onSubmit={formik.handleSubmit}>
                        <div className='row mt-3'>

                            {/* Current Password */}
                            <div className="col-lg-4 mb-5">
                                <TextField
                                    fieldType={'password'}
                                    fieldTitle={'Current Password'}
                                    filedTitleMandatory={true}
                                    fieldName={'currentPassword'}
                                    placeHolder={'Enter current password'}
                                    maxLength={'30'}
                                    handleOnChange={handleOnChange}
                                    formik={formik}
                                />
                            </div>

                            {/* New Password */}
                            <div className="col-lg-4 mb-5">
                                <div className="password-wrapper">
                                    <TextField
                                        fieldType={passwordShow}
                                        fieldTitle={'New Password'}
                                        filedTitleMandatory={true}
                                        fieldName={'newPassword'}
                                        placeHolder={'Enter new password'}
                                        maxLength={'30'}
                                        handleOnChange={handleOnChange}
                                        formik={formik}
                                    />

                                    <i
                                        className={`bi ${formik.errors.newPassword ? "password-toggle-while-error" : "password-toggle"} ${passwordShow === 'password' ? 'bi-eye-slash' : 'bi-eye'}`}
                                        onClick={toggleNewPassword}
                                    />
                                </div>
                            </div>

                            <div className="col-lg-4 mb-5">
                                <div className="password-wrapper">
                                    <TextField
                                        fieldType={passwordType}
                                        fieldTitle={'Confirm New Password'}
                                        filedTitleMandatory={true}
                                        fieldName={'confirmNewPassword'}
                                        placeHolder={'Confirm new password'}
                                        maxLength={'30'}
                                        handleOnChange={handleOnChange}
                                        formik={formik}
                                    />

                                    <i
                                        className={`bi ${formik.errors.confirmNewPassword ? "password-toggle-while-error" : "password-toggle"} ${passwordType === 'password' ? 'bi-eye-slash' : 'bi-eye'}`}
                                        onClick={toggleConfirmPassword}
                                    />
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className='border-top d-flex justify-content-end pt-5'>
                                <button
                                    type='button'
                                    className='btn btn-light me-3'
                                    onClick={removeEditMode}
                                >
                                    Cancel
                                </button>
                                <button
                                    type='submit'
                                    className='btn btn-primary'
                                >
                                    Update Password
                                </button>
                            </div>

                        </div>
                    </form>
                )}
            </div>
        </div>
    )
}

export default ResetPassword